<div class="counter" [hidden]="not_readed_count == 0" (click)="openDialog()">
  <i class="fa fa-envelope"></i>
  <span>{{not_readed_count}}</span>
</div>
